import React from 'react'

function WishList() {
  return (
    <h1>WishList Page</h1>
  )
}

export default WishList